import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import monthDropdown from '../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../Utilities/Constants/YesNoDropdown';
import DataContainer from '../../../Utilities/DataContainer';
import RenderSelectField from '../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../Utilities/Forms/ValidatedTextField';

//WS-03-A-17
interface IProps {
    isReadOnly: boolean
}
export default function TPShuttleBus({ isReadOnly }: IProps) {

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    <DataContainer title={"Shuttle Bus"}>
                        <Stack spacing={1}>
                            <RenderSelectField name="shuttleBusMain" label="Is there a shuttle bus facility provided by the site to main residential areas or between separate facilities of the same organisation?" readOnly={isReadOnly} options={yesNoDropdown} alwaysShow={true} />
                            <Grid size={12}>
                                <Typography variant={"body2"}>Date Implemented</Typography>
                            </Grid>
                            <Stack direction="row" spacing={1}>
                                <Grid size={6}>
                                    <ValidatedSelectElement name={'shuttleBusMainMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                </Grid>
                                <Grid size={6}>
                                    <ValidatedTextField name={'shuttleBusMainYear'} readOnly={isReadOnly} />
                                </Grid>
                            </Stack>
                            <RenderSelectField name="shuttleBusRail" label="Is there a shuttle bus facility provided by the site to rail stations and/or bus stations?" readOnly={isReadOnly} options={yesNoDropdown} alwaysShow={true} />
                            <Grid size={12}>
                                <Typography variant={"body2"}>Date Implemented</Typography>
                            </Grid>
                            <Stack direction="row" spacing={1}>
                                <Grid size={6}>
                                    <ValidatedSelectElement name={'shuttleBusRailMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                </Grid>
                                <Grid size={6}>
                                    <ValidatedTextField name={'shuttleBusRailYear'} readOnly={isReadOnly} />
                                </Grid>
                            </Stack>
                        </Stack>
                    </DataContainer>
                </Grid>

                <Grid size={4} container>
                    <DataContainer title={"Additional Comments"}>
                        <RenderTextField name="shuttleBusComments" label="Specify details of all Travel Plan elements identified in this section, along with any other marketing suites and sales staff features not already covered." multiLine={true} rows={4} inputSize={12} labelSize={12} readOnly={isReadOnly} alwaysShow={true} />
                    </DataContainer>
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12}>

                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
